
import EmbedModal from '~/components/globals/modal/embed'
import { getYoutubeVideoID, padNum } from '~/services/helpers'

export default
	props: block: Object
	inject: ['pageHash'] # Provide pagehash for updating featured video
	data: ->
		mounted: false
		page: 0
		dotSize: 0

	computed:
		# Video that is being played
		youtubeVideoUrl: -> @$store.state.videoModal.youtubeVideoUrl

		# Pagination to display
		activePage: -> padNum @page + 1

		# Left offset of the pagination index display
		paginationOffset: -> @page * (@dotSize + 8)

		paginationStyle: -> left: "#{@paginationOffset || 0}px"

		classes: -> [ "disable-overlay" if @block.disableOverlay, 'has-heading' if @block.heading ]

		# Carousel Responsive Props
		responsive: -> @responsiveProps || [
			{
				minWidth: 1024
				slidesPerPage: 3
				gutter: 32
			},
			{
				maxWidth: 1024
				slidesPerPage: 2
				gutter: 24
			},
			{
				maxWidth: 580,
				slidesPerPage: 1,
				gutter: 16
				overflowVisible: true
			},
		]

		carouselStyle: ->
			'--page': "#{ @page + 1 }"

	watch:
		youtubeVideoUrl: (url) ->
			if !url and @mounted then @removeHashFromLocation();

		page: -> @setDataPage()

	mounted: ->
		@setDataPage()
		@getPaginationDimension()
		window.addEventListener 'resize', @getPaginationDimension
		@mounted = true

	beforeDestroy: ->
		window.removeEventListener 'resize', @getPaginationDimension

	methods:
		setDataPage: ->
			page = @$el.querySelector '.ssr-carousel-dot-button'
			page?.setAttribute 'data-page', padNum @page + 1

		# Add video id to the url
		addHashToLocation: (params) ->
			history.pushState(
				{},
				null,
				@$route.path + '#' + encodeURIComponent(params)
			)

		removeHashFromLocation: () ->
			history.pushState(
				{},
				null,
				@$route.path
			)

		updatePage: (index) -> @page = index

		playVideo: (video) ->
			if video?.libraryVideo?.length
				mp4Video = video.libraryVideo[0]
				if mp4Video then @$store.commit 'videoModal/play', {video: mp4Video.videoDesktop?[0] || mp4Video.videoMobile?[0], title: mp4Video.title, subtitles: mp4Video.subtitles, libraryVideoId: mp4Video.id }


			else if video?.youtubeVideoUrl
				@addHashToLocation @makeVideoAnchor video
				@$store.commit('videoModal/play', video?.youtubeVideoUrl)

		makeVideoAnchor: (video) ->
			videoId = getYoutubeVideoID video?.youtubeVideoUrl || @youtubeVideoUrl
			return "video-#{videoId}-#{@block.id}"

		playVideoFromHash: ->
			split = @$route.hash.split('-')
			return unless split.length > 1

			videoId = split.slice(1, split.length-1).join '-'
			prefix = split[0]

			@$wait 500, =>
				if ["#video", "#mvideo", "#fvideo"].includes prefix
					@$store.commit 'videoModal/loadUrl', "https://www.youtube.com/watch?v=#{videoId}"
					scrollTo({top: window.pageYOffset + @$el.getClientRects?()?[0].top , behavior: 'smooth'})
					@$wait 1000, @playVideo

		getPaginationDimension: () ->
			dot = @$el.querySelector '.flickity-page-dots .dot'
			return unless dot
			@dotSize = dot.getClientRects()?[0].width

		goTo: (index) -> @$refs.carousel.goto index

		change: ({index}) -> @page = index

